import React, { useState, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { lookupMed } from 'helpers/medicationHelpers';
import moment from 'moment';
import { addHistoryToDb } from 'store/localDb';
import { getCurrentUserId } from 'store/storeValtio';
import chevUp from 'icons/ka-up-24.png';
import chevDown from 'icons/ka-down-24.png';
//import chevLeft from 'icons/chevron-left-24.png';
import { getNowISO, timeToMoment } from 'helpers/generalHelpers';
import MedicationTimePicker from './addMedication/MedicationTimePicker';

export default function TakeMedForm(props) {
  const [submitted, setSubmitted] = useState(false);
  const [howMany, setHowMany] = useState(2);
  const [day, setDay] = useState(3);
  const [ct, setCt] = useState(moment());
  const currentUserId = getCurrentUserId();
  const navigate = useNavigate();
  
  let params = useParams();
  const source = params.source;
  const medId = params.id;
  //console.log('TakeMedForm', props, params);
  //console.log('TakeMedForm', medId, source);

  const med = lookupMed(medId);

  const days = useMemo(() => {
    const d = [
      moment().subtract(3, 'days').format('MM/DD'),
      moment().subtract(2, 'days').format('MM/DD'),
      moment().subtract(1, 'days').format('MM/DD'),
      moment().format('MM/DD'),
    ];
    return d;
    },[]);

  let curDT = moment(); // use local time
  const howManyList = [
    "0.25",
    "0.5",
    "1",
    "1.5",
    "2",
    "3",
    "4",
  ];

  useMemo(() => {
    let hm = howManyList.indexOf(med.dosage);
    //console.log('hm', med.dosage, hm);
    if (hm < 0) hm = 2;
    setHowMany(hm);
    sel(day);
  },[])

  const initialValues = {
    date: getNowISO(),
    medicationId: '',
    userId: '',
    quantity: 1,
    status: 'taken',
  };

  const changeTime = (time) => {
    let mnt = timeToMoment(time);
    const d = 3 - day;
    //console.log('times', time, day, d, moment(), moment().local());
    if (d > 0) mnt.subtract(d, 'days');
    const tx = moment(mnt, 'MM/DD hh:mm A');
    //console.log('changeTime', mnt, tx);
    setCt(tx);
  };

  function exit() {
    //console.log('exit stage left');
    if (source === 'schedule') navigate('/schedule');
    else if (source === 'medications') navigate('/meds');
    else if (source === 'details') navigate(`/meds/${medId}`);
    else navigate('/');
  }

  async function handleSkip() {
    if(submitted) return;
    setSubmitted(true);
    initialValues.medicationId = med.medicationId;
    initialValues.date = ct.toISOString();
    initialValues.quantity = Number(howManyList[howMany]);
    initialValues.userId = currentUserId;
    initialValues.status = 'skipped';
    console.log('skipMed', initialValues);
    await addHistoryToDb(initialValues);
    exit();
  }

  async function onSubmit() {
    if(submitted) return;
    setSubmitted(true);
    initialValues.medicationId = med.medicationId;
    initialValues.date = ct.toISOString();
    initialValues.quantity = Number(howManyList[howMany]);
    initialValues.userId = currentUserId;
    console.log('takeMed', initialValues);
    await addHistoryToDb(initialValues);
    setSubmitted(false);
    exit();
  }

  function takeMore() {
    setHowMany(howMany<howManyList.length-1?howMany+1:howMany);
  }

  function takeLess() {
    setHowMany(howMany>0?howMany-1:0);
  }

  function sel(n) {
    //console.log('sel',day, n);
    let el = document.querySelector(`#D${day}`);
    if (!el) return;
    el.classList.remove('bg-yellow-600');
    el.classList.add('bg-gray-400');
    setDay(n);
    el = document.querySelector(`#D${n}`);
    el.classList.remove('bg-gray-400');
    el.classList.add('bg-yellow-600');
    setDay(n);
  }

  const ctStr = 'Take at ' + moment(ct).format('MM/DD hh:mm A');

  const howManyContainer = 'flex-initial flex-col select-none h-26 justify-between items-center mx-4 mb-1 px-2 border-2 rounded-md border-gray-600';
  const howManyText = 'text-base small:text-2xl font-bold text-center';
  const upDn = 'flex flex-row w-full justify-evenly text-base small:text-3xl font-extrabold';
  const upDnBtn = 'inline-flex justify-center items-center w-[30%] rounded-md bg-slate-300 border-2 mb-1';
  const upDnText = 'inline-flex justify-center items-center w-[30%] text-4xl text-center font-bold';
  const upDnIcon = 'w-8 small:w-16 hover:cursor-pointer';
  const dt = 'border-2 p-1 rounded-md font-bold bg-gray-400'

  return (
    <div className='mcard select-none'>
      <div className='mcard-body'>
        <div className='flex justify-between items-center h-16 small:h-24 py-1 text-lg small:text-xl phone:text-2xl text-white'>
          {/* <div className='hover:cursor-pointer' onClick={()=>navigate(-1)}>
              <img className='my-auto h-6 w-6' src={chevLeft} alt=''/>
          </div> */}
          <button onClick={onSubmit} disabled={submitted} className='rawBtn w-8/12 h-full my-1 bg-green-600 disabled:opacity-10'>
            {med.name}
            <br/>
            {ctStr}
          </button>
          <button onClick={handleSkip} className='rawBtn px-2 pl-2 w-3/12 h-full my-1 bg-red-600'>Skip</button>
        </div>
      </div>
      <div className={howManyContainer}>
        <div className={howManyText}>How many are you taking?</div>
        <div className={upDn}>
          <div className={upDnBtn} onClick={takeMore}>
            <img src={chevUp} alt='' />
          </div>
          <div className={upDnText}>
            {howManyList[howMany]}
          </div>
          <div className={upDnBtn} onClick={takeLess}>
            <img src={chevDown} alt='' />
          </div>
        </div>
      </div>
      {/* <TimePicker changeTime={changeTime} date={curDT} /> */}
      <MedicationTimePicker setTime={changeTime} doses={1} doseCount={1} curTime={curDT} />
        <div className='flex flex-row justify-around items-center mt-1 h-10 border-2 border-gray-700 rounded-md bg-slate-200' >
        <div id='D0' onClick={()=>sel(0)} className={dt}>{days[0]}</div>
        <div id='D1' onClick={()=>sel(1)} className={dt}>{days[1]}</div>
        <div id='D2' onClick={()=>sel(2)} className={dt}>{days[2]}</div>
        <div id='D3' onClick={()=>sel(3)} className={dt}>{days[3]}</div>
      </div>
    </div>
  );
}
